import "./IaxRoundButton.css";

export function IaxRoundButton({children, onClick}) {
  return (
    <div onClick={onClick} className="circle">
      <p className="insidecircle">
        {children}
      </p>
    </div>
  );
}
